import React, { useEffect, useState } from "react";
import "./LeavingCertificate.css"; // Create a CSS file for styling
import { baseUrl, currentDate } from "../../Utility/constants";
import axios from "axios";

const Attempt_CertificatePreview = ({studentId}) => {
  const [schoolId, setSchoolId] = useState("");
  const [certificateData, setCertificateData] = useState([]);
  const [schoolData, setSchoolData] = useState([]);
  
  useEffect(() => {
    const fetchCertificateData = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/api/PersonalDetails/ReturnStudentDetails?studentId=${studentId}`
        );
        if (response && response.data) {
          setCertificateData(response.data);
          if (response.data.schoolId) setSchoolId(response.data.schoolId);
        }
      } catch (error) {
        console.log(
          "Failed to fetch student details. Please try again.",
          error
        );
      }
    };

    fetchCertificateData();
  }, []);

  useEffect(() => {
    if (schoolId) {
      const fetchSchoolData = async () => {
        try {
          const response = await axios.get(
            `${baseUrl}/api/SchoolGeneralInfo/GetSchoolInfo?schoolId=${schoolId}`
          );
          if (response && response.data) {
            setSchoolData(response.data);
          }
        } catch (error) {
          console.log(
            "Failed to fetch student details. Please try again.",
            error
          );
        }
      };
      fetchSchoolData();
    }
  }, [schoolId]);



  return (
    <div className="certificate-container">
        <div>
        <table className="header-table">
          <tbody>
            <tr>
            <td style={{ width: "200px", verticalAlign:"middle", textAlign:"center" }}>
                <img src={schoolData.logo} className="responsive" width="150" />
              </td>
              <td style={{ borderRight: "none" }}>
                <b style={{ fontSize: "15px" }}>
                  {schoolData.organizationName}{" "}
                </b>
                <br />
                <b style={{ fontSize: "20px", fontWeight: "bold" }}>
                  {schoolData.schoolOrCollegeName}
                </b>
                <br />
                <b>(Affiliated to H.S.C. Board, Govt. Of Maharashtra)</b>
                <br />
                {/* Address : {schoolData.address}
                <br />
                Phone No. <b>{schoolData.schoolOrCollegeContactNo}</b> | Website
                : <b>{schoolData.schoolWebsiteName}</b>
                <br></br> */}
                Email : <b>{schoolData.email}</b>
                <br />
                U-DISE No : <b>{schoolData.udiseNo} </b> |{" "}
                {(schoolData.ssC10thIndexNo || schoolData.hsC12thIndexNo) && (
                  <>
                    Index No :
                    <b>
                      {schoolData.ssC10thIndexNo}
                      {schoolData.ssC10thIndexNo &&
                        schoolData.hsC12thIndexNo &&
                        " | "}
                      {schoolData.hsC12thIndexNo}
                    </b>
                  </>
                )}
              </td>
              <td style={{ width: "200px", borderLeft: "none" }}></td>
            </tr>
          </tbody>
        </table>
        <table className="header-table">
          <tbody>
            <tr>
              {/* First Column - School Recognition No */}
              <td style={{ width: "50%" }}>
                School / College Recognition No.
                <b>
                  {" "}
                  :{" "}
                  {schoolData.schoolRegistrationNumber &&
                    schoolData.schoolRegistrationNumber}
                  {schoolData.schoolRegistrationNumber &&
                    schoolData.collegeRegistrationNumber &&
                    " | "}
                  {schoolData.collegeRegistrationNumber &&
                    schoolData.collegeRegistrationNumber}
                </b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

     {/* Header */}
      <div className="col-md-12 mb-4 mt-3" style={{ textAlign: "center" }}>
      <h5 className="title d-inline-block mx-2 mt-4">ATTEMPT CERTIFICATE</h5>        
      </div>
      <div className="col-md-12 mb-4" style={{ textAlign: "justify" }}>
        This is to certify that{" "} 
        <b>
          {certificateData.firstName +
            " " +
            certificateData.middleName +
            " " +
            certificateData.lastName}{" "}
        </b>
        has completed <b>{certificateData.standardName} {certificateData.stream}</b> {" "}
        from <b>{schoolData.schoolOrCollegeName} {" "}</b>
        and He/She has passed the qualifying examination conducted by S.S.C/H.S.C Board, Pune.  
        In the month of <b>Feb/Mar-{new Date().getFullYear()}</b> in <b> First attempt </b>.
      </div>

      <div className="col-md-12 mb-4" style={{ textAlign: "justify" }}>
        Place: <br></br>
        <br></br>
        Date:  {currentDate()}<br></br> <br></br>
      </div>

      <div id="HeadmasterPrincipal mt-5">
        <span class="d-block text-end">
          Principal<br></br><br></br>
          {schoolData.schoolOrCollegeName}
        </span>
      </div>
    </div>
  );
};

export default Attempt_CertificatePreview;